import React, {state, useState, useRef} from "react";
import '@fontsource/montserrat'
import { ReactSketchCanvas } from "react-sketch-canvas";
import {
    Button,
    Box,
    Link,
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    FormControl
} from "@mui/material";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import styles from "./AccessCode.module.css"
import logo from "../../img/logo-small.png"
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { PDFDocument } from 'pdf-lib';


const SuccessPage = () => {


    return (
        <div className={styles.background}>
            
            <div className={styles.mainBox}>
                <img src={logo} alt="Loading Error" className={styles.logo}></img>
                <div className={styles.midBox} >
                    <div className={styles.bigText}>
                        Submission Accepted
                    </div>
                    <div className={styles.smallText}>
                       If you have any questions or concerns please contact Regional Dance America (RDA) at
                       <Typography sx={{ color: '#686673', lineHeight:'16px', marginBottom:'36px'}}>
                        {' '}
                        <Link 
                            href="mailto:programs@regionaldanceamerica.org" 
                            sx={{ 
                            color: '#B12F6B',       
                            textDecoration: 'none', 
                            '&:hover': {
                                color: '#E04F80',     
                                textDecoration: 'underline'
                            }
                            }}
                        >
                            programs@regionaldanceamerica.org
                        </Link>
                    </Typography>
                    </div>
                </div>
                <div style={{ height: '168px', visibility: 'hidden' }}></div>
                
                
            </div>

        </div>
    );
};

export default SuccessPage;